var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { fontSizes, spacing } from "syf-component-library/defaultTheme";
var TooltipButton = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  font-size: ", "px;\n  padding: 0;\n  border: none;\n  cursor: pointer;\n  background: none;\n  margin-left: ", "px;\n"], ["\n  display: inline-block;\n  font-size: ", "px;\n  padding: 0;\n  border: none;\n  cursor: pointer;\n  background: none;\n  margin-left: ", "px;\n"])), fontSizes.root, spacing.xsmall);
export default TooltipButton;
var templateObject_1;
//# sourceMappingURL=TooltipButton.js.map